<template>
  <div class="table-search-container">
    <a-input-search
      placeholder="医院名称"
      style="width: 225px"
      :allowClear="true"
      @search="(value) => $emit('onSearch', value)"
    />

    <a-select
      show-search
      placeholder="所有类型"
      style="width: 142px; margin: 0 0 0 23px"
      @change="(value) => $emit('onChange', value)"
      :allowClear="true"
    >
      <a-select-option
        v-for="item in selectData"
        :key="item.name"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>

    <a-select
      placeholder="请选择合作企业"
      v-model="companyId"
      style="width: 200px; margin: 0"
      @change="(value) => $emit('onChangecompany', value)"
    >
      <a-select-option
        v-for="item in companyData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.companyInfo.qichacha_name }}
      </a-select-option>
    </a-select>

    <a-dropdown placement="bottomLeft">
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        style="margin-left: 0px"
      >
        新增客户
      </a-button>
      <a-menu slot="overlay" @click="(even) => $emit('editAndAdd', even)">
        <a-menu-item key="0"> 医院 </a-menu-item>
        <a-menu-item key="4"> 药店 </a-menu-item>
        <a-menu-item key="3"> 商业公司 </a-menu-item>
        <!-- <a-menu-item key="2">
		      药店
		    </a-menu-item> -->
      </a-menu>
    </a-dropdown>

    <a-dropdown placement="bottomLeft">
      <a-button
        type="primary"
        shape="round"
        icon="upload"
        style="margin-left: 10px"
      >
        导入客户
      </a-button>
      <a-menu slot="overlay" @click="(even) => $emit('importShowSwitch', even)">
        <a-menu-item key="1"> 医院 </a-menu-item>
        <a-menu-item key="2"> 药店 </a-menu-item>
        <a-menu-item key="3"> 商业公司 </a-menu-item>
      </a-menu>
    </a-dropdown>

    <!-- <a-select show-search placeholder="选项" style="width: 142px; margin:0 23px;"
			@change="value => $emit('onChange', value)">
			<a-select-option v-for="item in selectData" :key="item.name" :value="item.id">
				{{ item.name }}
			</a-select-option>
		</a-select> -->

    <!-- <a-dropdown
      v-if="isShow"
      placement="bottomLeft"
    >
      <a-button
        type="primary"
        shape="round"
        icon="plus"
      >
        新增客户
      </a-button>
      <a-menu
        slot="overlay"
        @click="even => $emit('editAndAdd', even)"
      >
        <a-menu-item key="1">
          医院
        </a-menu-item>
        <a-menu-item key="2">
          药店
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <a-button
      v-else
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
    >
      {{ addText }}
    </a-button> -->
  </div>
</template>
<script>
export default {
  props: ["selectData", "addText", "isShow"],
  data() {
    return {
      companyData: [],
      companyId: "",
    };
  },
  mounted() {
    this.getCompanyList();
  },
  methods: {
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post("/Company/getCooperationCompanyList");
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
        this.companyId = this.companyData[0].id;
      }
    },
    filterOption(input, option) {
      // return (
      //   option.componentOptions.children[0].text
      //     .toLowerCase()
      //     .indexOf(input.toLowerCase()) >= 0
      // );
    },
  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;

  .ant-input {
    border-radius: 15px;
    height: 30px;
  }

  .ant-select-selection {
    border-radius: 15px;
    margin-right: 15px;
  }

  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
</style>
